'use es6';

import { Record } from 'immutable';
export default Record({
  panelOpen: false,
  eventToReplace: null
});